/** A touch that starts this close to the frame's bottom edge is on the
 * player's control strip and never starts a dismiss. */
const CONTROL_STRIP_PX = 80;
const CLOSE_DISTANCE_PX = 110;
const FLICK_MIN_DISTANCE_PX = 40;
const FLICK_MIN_SPEED_PX_PER_MS = 0.6;

export function startsOnControlStrip(
  touchY: number,
  frameBottom: number,
): boolean {
  return touchY > frameBottom - CONTROL_STRIP_PX;
}

/** How far the frame follows the finger: downward only. */
export function dragOffset(startY: number, currentY: number): number {
  return Math.max(0, currentY - startY);
}

/** Whether a finished downward swipe dismisses: dragged far enough, or a
 * short, fast flick. */
export function swipeDismisses(distance: number, elapsedMs: number): boolean {
  if (distance > CLOSE_DISTANCE_PX) return true;
  return (
    distance > FLICK_MIN_DISTANCE_PX &&
    distance / Math.max(1, elapsedMs) > FLICK_MIN_SPEED_PX_PER_MS
  );
}

/** The backdrop fades as the frame is dragged away, never below 0.3. */
export function backdropAlpha(distance: number): number {
  return Math.max(0.3, 0.92 - distance / 600);
}
